import Vue from 'vue';

Vue.component('index-accreditation', require('./components/application/IndexAccreditations').default);
Vue.component('index-appelations', require('./components/application/IndexApelations').default);
Vue.component('index-accreditationprocess', require('./components/application/IndexAccreditacionProcess').default);

// tabsT
Vue.component('tab-asign', require('./components/tabs/TabAsign').default);
Vue.component('tab-reasign', require('./components/tabs/TabReAsign').default);
Vue.component('tab-acusse-receipt', require('./components/tabs/TabAcusseReceipt').default);
Vue.component('tab-review', require('./components/tabs/TabReview').default);
Vue.component('tab-sendrevision', require('./components/tabs/TabSendRevision').default);

// 
Vue.component('modal-asign', require('./components/tabs/Modal/AsignModal').default);
Vue.component('modal-accusse-receipt', require('./components/tabs/Modal/AccuseReceipt').default);
Vue.component('modal-update', require('./components/tabs/Modal/SendModal').default);
// Vue.component('modal-review', require('./components/tabs/Modal/ReviewModal').default);
Vue.component('modal-review', require('./components/tabs/Modal/ModalPayment').default);

// Reasignar gestor
Vue.component('reasign-index', require('./components/reasign/Index').default);
// Vue.component('modal-update', require('./components/tabs/Modal/SendModal').default);

// Data accreditation application

Vue.component('accreditation-review', require('./components/form/Index').default);
Vue.component('form-general-review', require('./components/form/General').default);
Vue.component('form-organization-review', require('./components/form/Organization').default);
Vue.component('OrganizationParentReview', require('./components/form/OrganizationParent').default);
Vue.component('OrganizationBranchReview', require('./components/form/OrganizationBranch').default);
Vue.component('form-requets-review', require('./components/form/Request').default);
Vue.component('form-detail-review', require('./components/form/Detail').default);
Vue.component('form-responsable-review', require('./components/form/Responsable').default);
Vue.component('form-annexes-review', require('./components/form/Annexes').default);
Vue.component('AnnexedFileReview', require('./components/form/AnnexedFile').default);
Vue.component('form-commitment-review', require('./components/form/ComplianceCommitment').default);
Vue.component('form-sendrequest-review', require('./components/form/SendRequest').default);

/**
 * RARC
 */
// Equipo Evaluador
Vue.component('evaluation-team-302-tabs', require('./components/evaluation-team/Tabs').default);
// Aprobacion de Planificacion
Vue.component('planning-approval-302-table', require('./components/evaluation-team/planning-approval/Index').default);
Vue.component('planning-approval-302-modal', require('./components/evaluation-team/planning-approval/Modal').default);
// Revisar Objeciones
Vue.component('review-objections-308-table', require('./components/evaluation-team/review-objections/Index').default);
Vue.component('review-objections-308-modal', require('./components/evaluation-team/review-objections/Modal').default);

// Decision
Vue.component('decision-608-tabs', require('./components/decision/Tabs').default);
Vue.component('area-director-report-table', require('./components/decision/area-director-report/Index').default);
Vue.component('area-director-report-tabs', require('./components/decision/area-director-report/Tabs').default);
Vue.component('area-director-report-annexes', require('./components/decision/area-director-report/annexes/Index').default);
Vue.component('area-director-report-annexes-modal', require('./components/decision/area-director-report/annexes/Modal').default);


// Extension de tiempo
Vue.component('extension-time-tabs', require('./components/extension-time/Tabs').default);
Vue.component('extension-time-request-table', require('./components/extension-time/extension-time-request/Index').default);
Vue.component('extension-time-modal', require('./components/extension-time/extension-time-request/Modal').default);

Vue.component('extension-time-request-table602', require('./components/extension-time/602/Index').default);
Vue.component('extension-time-modal602', require('./components/extension-time/602/Modal').default);

// Vigilancias
Vue.component('index-vigilancias', require('./components/vigilances/IndexVigilances').default);
Vue.component('vigilance-modal', require('./components/vigilances/ModalVigilances').default);

//Director de area documento de quejas
Vue.component('area-diretor-complaint-document-table', require('./components/areaDirectorComplaintDocument/ComplaintIndex').default); 
// Vue.component('area-diretor-complaint-document-table', require('./components/areaDirectorComplaintDocument/Index').default);
Vue.component('area-diretor-complaint-document-assignment', require('./components/areaDirectorComplaintDocument/Assignment').default); 
Vue.component('area-diretor-complaint-document-approved', require('./components/areaDirectorComplaintDocument/Approved').default); 
Vue.component('area-diretor-complaint-document-tabs', require('./components/areaDirectorComplaintDocument/Tabs').default);
Vue.component('area-diretor-complaint-document-tapproved', require('./components/areaDirectorComplaintDocument/705/Tabs').default);
Vue.component('area-diretor-complaint-document-702', require('./components/areaDirectorComplaintDocument/702/Index').default);
Vue.component('area-diretor-complaint-document-annexed', require('./components/areaDirectorComplaintDocument/705/Annexed').default);
Vue.component('area-diretor-complaint-document-file', require('./components/areaDirectorComplaintDocument/705/Complaint').default);


//alcance 608
Vue.component('scopes-evaluator-indexx', require('./components/decision/area-director-report/scopes/Index').default);
Vue.component('scopes-evaluator-tablee', require('./components/decision/area-director-report/scopes/Table').default);
Vue.component('sampling-evaluator-sam-indexx', require('./components/decision/area-director-report/scopes/sampling/IndexSam').default);
Vue.component('sampling-evaluator-historical-modall', require('./components/decision/area-director-report/scopes/sampling/HistoricalModal').default);

//Director de area Juridico documento de quejas 
Vue.component('area-legal-document-table', require('./components/areaLegalDocument/Index').default);
Vue.component('area-legal-document-tabs', require('./components/areaLegalDocument/Tabs').default);
Vue.component('area-legal-document-702', require('./components/areaLegalDocument/702/Index').default);

